import initialState from '../initialstate';
import * as actions from '../../actions/actiontypes';

export default function isValidUserWithProjectAvailablereducer(
	state = initialState.isValidUserWithProjectAvailable,
	action
) {
	switch (action.type) {
		case actions.IS_VALID_USER_WITH_PROJECT_AVAILABLE:
			let newState = {...state};
			if (action.error) {
				newState.result = false;
				if (action.error?.response?.data?.error?.code) {
					newState.errorCode = action.error.response.data.error.code;
				}
			} else {
				newState.result = action.response?.result;
			}
			return newState;
		default:
			return state;
	}
}
